import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOP_ThisPointer = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title='Classes and Objects: "this" Pointer'
      videos={[
        "https://www.youtube.com/embed/_8H2n0nDfd4", // C++ CLASSES & OBJECTS explained easy
        "https://www.youtube.com/embed/vic6QvHxJPA", // this Pointer in C++
        "https://www.youtube.com/embed/t3_uhJpKm9k", // Defining member function outside the class
        "https://www.youtube.com/embed/Riq8R4LxrKo", // Member function inside and outside the class
        "https://www.youtube.com/embed/uYXrJlz8rek", // Access Specifiers in C++
      ]}
      takeaways={[ 
        { text: 'Questions can be asked like "What is the importance of the `this` pointer?"' },
        { text: "Learn about access specifiers (public, private, and protected)." },
        { text: "Programming questions from classes and objects are common." },
      ]}
      questions={[
        "1) Write a C++ program to create a base class Quadrilateral with member functions - setDimensions() and calculatePerimeter() to get four double type values. Also, create a derived class Rectangle with a member function calculateArea() that calculates the area of the rectangle. Create two objects of the class Rectangle in the main function and display the results.",
        "2) With a neat example, show how a member function can be defined outside the class.",
      ]}
      exampleVideos={[]} // No example question videos provided
    />
);
}

export default OOP_ThisPointer;
